import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { IFetchCampaignsParams } from '../campaigns.store';
import { IDatatableParamsPrepareParameters } from './campaigns-datatable.interface';

@Injectable({
  providedIn: 'root',
})
export class CampaignsDatatableService {
  public prepareFetchCampaignsParams(parameters: IDatatableParamsPrepareParameters): IFetchCampaignsParams {
    const { params, campaignIds, isForAnalytics, requestFilters, requestJoins, creatorMode, adminMode } = parameters;

    if (!params) {
      return {
        ...(campaignIds ? { campaignIds } : {}),
        adminMode,
        creatorMode,
        ctaTemplates: isForAnalytics,
        isForAnalytics,
        params: {
          limit: 5,
          page: 0,
          sort: [{ active: 'created_at', direction: 'desc' }],
          ...(requestFilters && Object.keys(requestFilters ?? {}).length
            ? { filters: { ...(requestFilters ? { ...requestFilters } : {}) } }
            : {}),
          ...(requestJoins?.length ? { joins: requestJoins } : {}),
        },
      };
    }

    return {
      ...(campaignIds ? { campaignIds } : {}),
      adminMode,
      creatorMode,
      ctaTemplates: isForAnalytics,
      isForAnalytics,
      params: {
        limit: params.limit,
        page: params.page,
        sort: [this.prepareSort(params.sort)],
        ...(requestJoins?.length ? { joins: requestJoins } : {}),
        ...((params.filters && Object.keys(params.filters).length) ||
        (requestFilters && Object.keys(requestFilters ?? {}).length)
          ? {
              filters: {
                ...(params.filters ? { ...params.filters } : {}),
                ...(requestFilters ? { ...requestFilters } : {}),
              },
            }
          : {}),
        ...(params.search ? { search: { searchedFields: ['name__ilike'], searchText: params.search } } : {}),
      },
    };
  }

  private prepareSort(sort: Sort): Sort {
    if (sort.active === 'startFormatted') {
      return { ...sort, active: 'start' };
    }

    if (sort.active === 'endFormatted') {
      return { ...sort, active: 'end' };
    }

    return sort;
  }
}
